import React, { useEffect, useState } from 'react';
import './roominfo.css';
import { useMessageStore } from './store/store';

// Map font size names to CSS values
const FONT_SIZE_MAP = {
    small: '0.85rem',
    medium: '0.92rem',
    large: '1.02rem',
    xlarge: '1.12rem'
};

function RoomInfo({ sendMessage, roomInfo }) {
    // Get font settings from store
    const consoleFontFamily = useMessageStore((state) => state.consoleFontFamily);
    const consoleFontSize = useMessageStore((state) => state.consoleFontSize);
    const [directions, setDirections] = useState({ north: false, south: false, east: false, west: false, up: false, down: false });
    const [exits, setExits] = useState([]);

    useEffect(() => {
        const parsedDirections = parse(roomInfo.exits);
        const filterExits = Object.entries(parsedDirections)
            .filter(([key, val]) => val === true)
            .map(([key]) => key.charAt(0).toUpperCase() + key.slice(1));

        const formatExits = [];

        for (let i = 0; i < filterExits.length; i++) {
            if (i > 0) {
                formatExits.push(i === filterExits.length - 1 ? ' and ' : ', ');
            }
            formatExits.push(<span key={i} className='active' onMouseDown={(e) => move(filterExits[i])} onMouseUp={(e) => stopMoving()}>{filterExits[i]}</span>);
        }
        setExits(formatExits);
        setDirections(parsedDirections);
    }, [roomInfo]);

    const move = (direction) => {
        sendMessage('310' + direction);
    }
    const stopMoving = () => {
        move('stop');
    }

    const getItem = (i, amount) => {
        sendMessage('600/get ' + amount + " " + i);
    }

    const RoomItem = ({ roomItem, getItem, index }) => {
        const [amount, setAmount] = useState(roomItem.qty);

        return (
            <div className='room-item'>
                <img src={require('./Assets/gfx/' + roomItem.picId + '.webp')} style={{ borderColor: roomItem.colour === "#829dba" ? '' : roomItem.colour }} alt='' />
                <p className='room-exit-text' style={{ color: roomItem.colour }}>{roomItem.name}</p>
                <div className='get-item'>
                    <input type="number" className="amount" min={1} max={roomItem.qty} defaultValue={roomItem.qty}
                        onChange={(e) => setAmount(Number(e.currentTarget.value))} />
                    <button onClick={(e) => getItem(index, amount)}>Get</button>
                </div>
            </div>
        )
    }

    // Build CSS custom properties for font settings
    const fontStyles = {
        '--console-font-family': `"${consoleFontFamily}", monospace`,
        '--console-font-size': FONT_SIZE_MAP[consoleFontSize] || FONT_SIZE_MAP.medium
    };

    return (
        <>
            <section className='room-panel' style={fontStyles}>
                <header className='room-title-text'>{roomInfo.title}</header>
                <p className='room-description'>{roomInfo.desc}</p>
                <p className='room-exit-text'>Exits: {(exits)}.</p>
                <div className='room-container'>

                    <div className='room-exits'>
                        <button className={'material-symbols-outlined exit exit-north ' + (directions.north ? 'active' : 'inactive')} onMouseDown={(e) => move("north")} onMouseUp={(e) => stopMoving()} onTouchStart={(e) => move("north")} onTouchEnd={(e) => stopMoving()}>
                            keyboard_arrow_up
                        </button>
                        <button className={'material-symbols-outlined exit exit-west ' + (directions.west ? 'active' : 'inactive')} onMouseDown={(e) => move("west")} onMouseUp={(e) => stopMoving()} onTouchStart={(e) => move("west")} onTouchEnd={(e) => stopMoving()}>
                            keyboard_arrow_left
                        </button>
                        <button className={'material-symbols-outlined exit exit-east ' + (directions.east ? 'active' : 'inactive')} onMouseDown={(e) => move("east")} onMouseUp={(e) => stopMoving()} onTouchStart={(e) => move("east")} onTouchEnd={(e) => stopMoving()}>
                            keyboard_arrow_right
                        </button>
                        <button className={'material-symbols-outlined exit exit-south ' + (directions.south ? 'active' : 'inactive')} onMouseDown={(e) => move("south")} onMouseUp={(e) => stopMoving()} onTouchStart={(e) => move("south")} onTouchEnd={(e) => stopMoving()}>
                            keyboard_arrow_down
                        </button>
                        <div className='exit-mid'>
                            <div className='holder'>
                                <button className={'material-symbols-outlined exit exit-up ' + (directions.up ? 'active' : 'inactive')} onMouseDown={(e) => move("up")} onMouseUp={(e) => stopMoving()} onTouchStart={(e) => move("up")} onTouchEnd={(e) => stopMoving()}>
                                    north
                                </button>
                                <button className={'material-symbols-outlined exit exit-down ' + (directions.down ? 'active' : 'inactive')} onMouseDown={(e) => move("down")} onMouseUp={(e) => stopMoving()} onTouchStart={(e) => move("down")} onTouchEnd={(e) => stopMoving()}>
                                    south
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='ground'>
                        {
                            roomInfo.items.map((e, i) => <RoomItem roomItem={e} getItem={getItem} index={i} />)
                        }
                    </div>
                </div>

            </section>
        </>
    );
}





function parse(exits) {
    const direction = exits.split("/");
    let north = false;
    let south = false;
    let east = false;
    let west = false;
    let up = false;
    let down = false;

    for (let i = 0; i < direction.length; i++) {
        if (direction[i] === 'n') {
            north = true;
        }
        if (direction[i] === "e") {
            east = true;
        }
        if (direction[i] === "w") {
            west = true;
        }
        if (direction[i] === "s") {
            south = true;
        }
        if (direction[i] === "d") {
            down = true;
        }
        if (direction[i] === "u") {
            up = true;
        }
    }
    return { north: north, south: south, east: east, west: west, up: up, down: down };
}

export default RoomInfo;